import React from "react";
import { Box, Button, CardContent, Typography } from "@mui/material";
import { GridGenerator } from "@actinc/dls/components";
import { useForm } from "react-hook-form";

import { AlertDialog, ControlledFormInput } from "../../../../components";

const TaskDetailsDialog = ({ onClose, objectType, row }) => {
  const { control } = useForm({
    mode: "all",
    defaultValues: { ...row },
  });

  const taskDetailsDialogProps = {
    open: true,
    dialogTitle: `Task Details - ${row.taskName}`,
    customFooter: (
      <>
        <Button onClick={onClose} variant="text">
          Close
        </Button>
      </>
    ),
  };

  return (
    <AlertDialog {...taskDetailsDialogProps}>
      <form id="task-details-dialog-form">
        <GridGenerator
          groups={[
            [
              {
                children: (
                  <ControlledFormInput
                    control={control}
                    readonly={true}
                    fullWidth={true}
                    id="program"
                    label="Program"
                    name="program"
                  />
                ),
                key: "task-details-program",
              },
              {
                children: (
                  <ControlledFormInput
                    control={control}
                    readonly={true}
                    fullWidth={true}
                    id="contentArea"
                    label="Content Area"
                    name="contentArea"
                  />
                ),
                key: "task-details-content-area",
              },
            ],
            [
              {
                children: (
                  <ControlledFormInput
                    control={control}
                    readonly={true}
                    fullWidth={true}
                    id="name"
                    label={objectType + " Name"}
                    name="name"
                  />
                ),
                key: "task-details-item-name",
              },
              {
                children: objectType === "Item" && (
                  <ControlledFormInput
                    control={control}
                    readonly={true}
                    fullWidth={true}
                    id="itemFormat"
                    label="Item Format"
                    name="itemFormat"
                  />
                ),
                key: "task-details-item-format",
              },
            ],
            [
              {
                children: (
                  <ControlledFormInput
                    control={control}
                    readonly={true}
                    fullWidth={true}
                    id="gradeLevel"
                    label="Grade"
                    name="gradeLevel"
                  />
                ),
                key: "task-details-gradeLevel",
              },
              {
                children: (
                  <ControlledFormInput
                    control={control}
                    readonly={true}
                    fullWidth={true}
                    id="requestedDateTime"
                    label="Request Date"
                    name="requestedDateTime"
                  />
                ),
                key: "task-details-requested-date-time",
              },
            ],
          ]}
        />
        {row.imageDetails?.map((image, i) => (
          <Box key={image} sx={{ border: "1px dashed grey" }}>
            <Typography variant="h6" sx={{ color: "primary.main", ml: 1 }}>
              Component: {image.component}
            </Typography>
            <GridGenerator
              groups={[
                [
                  {
                    children: image.file && (
                      <>
                        <CardContent>
                          <img alt="task-details-preview" src={image.file} />
                        </CardContent>
                      </>
                    ),
                    key: `task-details-image-preview-${i}`,
                  },
                ],
                [
                  {
                    children: (
                      <Typography variant="h6" sx={{ ml: 2 }}>
                        Art Type
                        <Typography variant="body1">{image.type}</Typography>
                      </Typography>
                    ),
                    key: `task-details-request-type-${i}`,
                  },
                  {
                    children: (
                      <Typography variant="h6">
                        Color Format
                        <Typography variant="body1">{image.format}</Typography>
                      </Typography>
                    ),
                    key: `task-details-color-format-${i}`,
                  },
                ],
                [
                  {
                    children: (
                      <Typography variant="h6" sx={{ ml: 1 }}>
                        Description
                        <Typography
                          variant="body1"
                          dangerouslySetInnerHTML={{
                            __html: image.description,
                          }}
                        />
                      </Typography>
                    ),
                    key: `task-details-request-description-${i}`,
                  },
                ],
              ]}
            />
          </Box>
        ))}
      </form>
    </AlertDialog>
  );
};

export { TaskDetailsDialog };
